import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import { SettingsSubGroup } from '../../SettingsSubGroup';
import { SocialMediaSettingsServiceConnectionStatus } from './presentation';
import { SocialMediaSignatureComposer } from './SocialMediaSignatureComposer';
import { styleSheet } from './styles';

export const SocialMediaSettings = observer(() => {
	const userSession = useUserSession();
	const connectionsContainerRef = React.useRef<HTMLDivElement>(null);

	// create a dictionary of vms for the supported services
	const vms = React.useRef<Record<string, Api.SocialMediaViewModel>>(
		Api.SupportedSocialMediaTypes.reduce<Record<string, Api.SocialMediaViewModel>>((result, x) => {
			switch (x) {
				case Api.SocialMediaType.Facebook: {
					result[x] = new Api.FacebookViewModel(userSession);
					break;
				}
				case Api.SocialMediaType.Instagram: {
					result[x] = new Api.InstagramViewModel(userSession);
					break;
				}
				case Api.SocialMediaType.LinkedIn: {
					result[x] = new Api.LinkedInViewModel(userSession);
					break;
				}
				default: {
					break;
				}
			}
			return result;
		}, {})
	).current;

	// Refresh ViewModels when user's social media connections change
	React.useEffect(() => {
		Api.SupportedSocialMediaTypes.forEach(type => {
			vms[type]?.refreshConnectionsFromUserSession();
		});
	}, [userSession?.user?.socialMediaConnectedAccounts, vms]);

	// Note: Connection result handling is now done in the global SocialMediaConnectionProvider.
	// The provider handles post target selection and displays modals from any page in the app.

	return (
		<>
			<SettingsSubGroup title='Connect Social Media Accounts' titleClassName='Social'>
				<div className={css(styleSheet.serviceConnections)} ref={connectionsContainerRef}>
					{Api.SupportedSocialMediaTypes.map(x => {
						const vm = vms[x];
						return vm ? (
							<SocialMediaSettingsServiceConnectionStatus
								key={x}
								viewModel={vm}
								readOnly={userSession?.account?.features?.socialMedia?.readOnly}
							/>
						) : null;
					}).filter(Boolean)}
				</div>
			</SettingsSubGroup>{' '}
			<SettingsSubGroup
				title='Social Media Signature'
				titleClassName='Social'
				className={css(styleSheet.signatureSubGroup)}
			>
				<SocialMediaSignatureComposer />
			</SettingsSubGroup>
		</>
	);
});
